import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=463a988f&scoped=true"
import script from "./AddDialog.vue?vue&type=script&lang=js"
export * from "./AddDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDialog.vue?vue&type=style&index=0&id=463a988f&prod&lang=scss"
import style1 from "./AddDialog.vue?vue&type=style&index=1&id=463a988f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a988f",
  null
  
)

export default component.exports